import { msalService } from "./msal.service";
import { googleAuthService } from "./google_auth.service";

let _refreshPromise = null;
let _refreshTimer = null;

async function refreshAccessToken() {
  if (_refreshPromise) return _refreshPromise;
  _refreshPromise = _doRefresh().finally(() => { _refreshPromise = null; });
  return _refreshPromise;
}

async function _doRefresh() {
  const provider = localStorage.getItem("auth_provider");

  if (provider === "microsoft") {
    const accessToken = await msalService.silentRefresh();
    localStorage.setItem("token", accessToken);
    return accessToken;
  }

  if (provider === "google") {
    const accessToken = await googleAuthService.silentRefresh();
    localStorage.setItem("token", accessToken);
    return accessToken;
  }

  const refreshToken = localStorage.getItem("refresh");
  if (!refreshToken || refreshToken === "null" || refreshToken === "undefined") {
    throw new Error("No refresh token");
  }

  const response = await fetch(
    `${process.env.VUE_APP_GATEWAY_URL}auth/refresh`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh: refreshToken, provider: provider || "local" })
    }
  );

  if (!response.ok) throw new Error("Refresh failed");

  const data = await response.json();
  localStorage.setItem("token", data.access);
  if (data.refresh) localStorage.setItem("refresh", data.refresh);
  return data.access;
}

function _getTokenExpiry(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

// Schedules a proactive refresh 2 minutes before the token expires.
// onRefresh(newToken) is called after each successful refresh.
function scheduleProactiveRefresh(onRefresh) {
  cancelProactiveRefresh();
  const token = localStorage.getItem("token");
  if (!token) return;

  const expiry = _getTokenExpiry(token);
  if (!expiry) return;

  const delay = Math.max(0, expiry - Date.now() - 2 * 60 * 1000);
  _refreshTimer = setTimeout(async () => {
    try {
      const newToken = await refreshAccessToken();
      if (onRefresh) onRefresh(newToken);
      scheduleProactiveRefresh(onRefresh);
    } catch {
      // Reactive 401 interceptor will handle it on the next request
    }
  }, delay);
}

function cancelProactiveRefresh() {
  if (_refreshTimer) {
    clearTimeout(_refreshTimer);
    _refreshTimer = null;
  }
}

export { refreshAccessToken, scheduleProactiveRefresh, cancelProactiveRefresh };
export const tokenService = { refreshAccessToken, scheduleProactiveRefresh, cancelProactiveRefresh };
